//@flow
import React, { useCallback, useRef } from "react";
import { connect } from "react-redux";

import { Spinner } from "@quantum/ui";
import { Translate } from "@quantum/i18n";

import { carregandoFuncaoQtLink, getFuncaoQtLink } from "../../state";

import { bindModal, useModal, Modal } from "../comum";

import "./modal-funcao-qt-link.css";
// $FlowFixMe Flow doesn't support SVG imported as components
import { ReactComponent as CopiarIcone } from "../../assets/copiar_funcao_qtlink.svg";

type Props = {
  carregando: boolean,
  funcaoQtLink: string,
};

const hidden = { visibility: "hidden" };

function ModalFuncaoQtLink({ carregando, funcaoQtLink }: Props) {
  const modal = useModal("qtlink");

  const textAreaRef = useRef();

  const handleCopiar = useCallback(() => {
    const textArea = textAreaRef.current;
    if (textArea) {
      textArea.focus();
      textArea.select();
      document.execCommand("copy");
    }
  }, [textAreaRef]);

  return (
    <Modal
      {...bindModal(modal)}
      dialogClassName={"modalFuncaoQtLink"}
      mountOnShow
      transition
    >
      <Modal.Header closeButton>
        <Modal.Title>
          <span className={"spanDoubleColon"}>::</span>
          <span className={"spanCopiarCodigo"}>
            <Translate>
              configuracaoRelatorio.exportarFuncao.copiarCodigo
            </Translate>
          </span>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {carregando && <Spinner />}
        <div style={carregando ? hidden : {}}>
          <sub>
            <Translate>excel.vinculado.funcao.copiar</Translate>
          </sub>
          <div className={"divCopiarFuncaoQtLink"} onClick={handleCopiar}>
            <CopiarIcone className={"iconeCopiarFuncao"} />
            <span className={"btnCopiarFuncao"}>
              <Translate>botao.COPIAR</Translate>
            </span>
          </div>
        </div>
        <textarea
          style={carregando ? hidden : {}}
          ref={textAreaRef}
          className="textoFuncaoQtLink"
          readOnly
          spellCheck={false}
          value={funcaoQtLink}
        />
      </Modal.Body>
    </Modal>
  );
}

export default connect(state => ({
  carregando: carregandoFuncaoQtLink(state),
  funcaoQtLink: getFuncaoQtLink(state),
}))(ModalFuncaoQtLink);
